export default (state) => {
    return {
        ...state,
        currentOrganization: state.organizations[state.currentOrganizationID] || Object.values(state.organizations)[0]
    }
}